import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { AwsSupplierManagementService } from 'src/app/services/main/home/supplier-management/aws-supplier-management.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-log-kraljic',
  templateUrl: './log-kraljic.component.html',
  styleUrls: ['./log-kraljic.component.scss']
})
export class LogKraljicComponent implements OnInit {
  loadingData = false;
  @Input() activities = [];
  @Input() supplier = "";
  @Input() idCompany = "";
  ExclusiveStartKey = null;
  subscriber: Subscription;
  constructor(private globalService: GlobalService,  private aws: AwsSupplierManagementService) { 
   
  }

  ngOnInit(): void {

  }
}
